// extracted by mini-css-extract-plugin
export default {"warningModalControls":"ReportGenerationWarningModal_warningModalControls__M07sP"};